import { render, staticRenderFns } from "./AddUserCard.vue?vue&type=template&id=2454cc72&scoped=true&"
import script from "./AddUserCard.vue?vue&type=script&lang=js&"
export * from "./AddUserCard.vue?vue&type=script&lang=js&"
import style0 from "./AddUserCard.vue?vue&type=style&index=0&id=2454cc72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2454cc72",
  null
  
)

export default component.exports